import { matchPath, useLocation } from "react-router-dom";
import Seo from "./Seo";
import {
  collectionSeo,
  industrySeo,
  operationsSeo,
  staticSeo,
} from "../../data/seo";
import { blogPosts } from "../../data/blog";

const blogBySlug = Object.fromEntries(blogPosts.map((post) => [post.slug, post]));

function decode(text = "") {
  return text
    .replace(/&#(\d+);/g, (_, n) => String.fromCharCode(Number(n)))
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function blogDescription(excerpt = "") {
  const text = decode(excerpt).replace(/\s*\[\.\.\.\]\s*$/, "");
  return text.length > 155 ? `${text.slice(0, 152).replace(/\s+\S*$/, "")}...` : text;
}

function resolveMeta(path) {
  if (staticSeo[path]) return staticSeo[path];

  const industry = matchPath("/industries/:slug", path);
  if (industry) return industrySeo[industry.params.slug] || null;

  const operations = matchPath(
    "/ai-infrastructure/ai-data-operations/:slug",
    path,
  );
  if (operations) return operationsSeo(operations.params.slug);

  const collection = matchPath(
    "/ai-infrastructure/data-collection/:slug",
    path,
  );
  if (collection) return collectionSeo(collection.params.slug);

  const blog = matchPath("/resources/blogs/:slug", path);
  if (blog) {
    const post = blogBySlug[blog.params.slug];
    if (post) {
      return {
        title: `${decode(post.title)} | Qualitas Global`,
        description: blogDescription(post.excerpt),
      };
    }
  }

  return null;
}

export default function RouteSeo() {
  const { pathname } = useLocation();
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const meta = resolveMeta(path);

  if (!meta) {
    return (
      <Seo
        title="Page not found | Qualitas Global"
        description="The page you are looking for does not exist or may have moved."
        noindex
      />
    );
  }

  return <Seo title={meta.title} description={meta.description} />;
}
